import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Magnetic hover wrapper for premium CTAs. Renders a Link if `to` given, else a button.
export default function MagneticButton({
  to,
  onClick,
  children,
  className = "",
  strength = 0.4,
  "data-testid": testId,
}) {
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const handleMove = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const x = (e.clientX - (rect.left + rect.width / 2)) * strength;
    const y = (e.clientY - (rect.top + rect.height / 2)) * strength;
    setPos({ x, y });
  };
  const reset = () => setPos({ x: 0, y: 0 });

  const content = (
    <span className="inline-flex items-center justify-center gap-3">
      {children}
    </span>
  );

  return (
    <motion.div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={reset}
      animate={{ x: pos.x, y: pos.y }}
      transition={{ type: "spring", stiffness: 200, damping: 15, mass: 0.1 }}
      style={{ display: "inline-block" }}
    >
      {to ? (
        <Link to={to} data-testid={testId} className={`inline-flex ${className}`}>
          {content}
        </Link>
      ) : (
        <button type="button" onClick={onClick} data-testid={testId} className={`inline-flex ${className}`}>
          {content}
        </button>
      )}
    </motion.div>
  );
}
